import { render, staticRenderFns } from "./zhenheyi.vue?vue&type=template&id=01d79390&"
import script from "./zhenheyi.vue?vue&type=script&lang=js&"
export * from "./zhenheyi.vue?vue&type=script&lang=js&"
import style0 from "./zhenheyi.vue?vue&type=style&index=0&id=01d79390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports